import { SecurityType } from '../../../../../graphql';

export const securityTypeOfferingHeaderLabels = {
  [SecurityType.CommonOrdinaryShare]: 'Shares',
  [SecurityType.ConvertibleBond]: 'Notes',
  [SecurityType.LimitedPartnershipUnit]: 'Units',
  [SecurityType.PreferredShare]: 'Shares',
  [SecurityType.UnitShareAndWarrants]: 'Shares',
};
